<template>
  <div id="Tbar" :class="$mq">
    <div class="wrapper h-inherit noselect flex justify-between">

      <!-- logo -->
      <router-link
        to="/" exact
        tag="div"
        id="cookbook-logo"
        :class="{ 'router-link-active': $route.name === 'aihe' }"
      >
        <img src="@/assets/cb_logo.svg" alt="">
        <span class="relative font-ui-main font-logo">Ketterä</span>
        <!-- <span class="version">beta</span> -->

        <!-- logout button -->
        <i v-if="$store.state.isLogged" @click="logout" class="material-icons ml-6 font-10" style="color: rgb(255, 187, 0);">lock</i>
      </router-link>

      <!-- enhanced_encryption https lock -->

      <!-- keinot / kohteet -->
      <div id="navdiv" :class="$mq" class="flex justify-end h-inherit">
          <router-link
            v-for="(link, index) in tBarLinks"
            :key="index"
            :to="{ name: link.to }"
            tag="div"
            @click="selected = link.id"
            class="flex justify-start align-center ml-5 color-white"
          >
            <img :src="require('../assets/cb_' + link.to + '.svg')" alt="" class="pr-1-5">
            <span class="font-9 txt-bold pr-1">{{ link.to }}</span>
          </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import firebase from 'firebase'

export default {
  name: 'Tbar',
  data () {
    return {
      selected: undefined,
      tBarLinks: [
        { to: 'keinot', id: 'a', icon: '../assets/cb_keinot.svg' },
        { to: 'kohteet', id: 'b', icon: '../assets/cb_kohteet.svg' }
      ]
    }
  },

  computed: {
    ...mapState(['intro'])
  },

  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        this.$cookie.delete('isLogged')
        this.$store.dispatch('setLoggedState', false)
        this.$router.push({ name: 'home' })
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#Tbar {
  z-index: 9999;
  position: relative;
  width: 100%;
  height: $Tbar-height;
  padding: 0 1rem;
  background-color: color(ui-main);
  box-shadow: 0 1.5px 2px rgba(0, 0, 0, 0.2);
  /* &.phone { height: $Tbar-height-phone; } */ //SÄÄDÄ LOPUKSI!
  #cookbook-logo {
    /* float: left; */
    position: relative;
    display: inline-block;
    height: $Tbar-height;
    border-bottom: solid 3px transparent;
    display: inline-flex;
    align-items: center;
    font-size: 1.6rem !important;
    color: white;
    cursor: pointer;
    &.router-link-active { border-bottom: solid 3px rgb(255, 187, 0); }
    /* img {
      height: 90%;
      filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3));
    } */
    span:after {
      content: 'beta';
      position: absolute;
      //top: 10px;
      right: -22px;
      font-size: 0.6rem;
    }
    /* span.version {
      position: absolute;
      top: 10px;
      right: -22px;
      font-size: 0.6rem;
    } */
    img {
      height: 1.4rem;
      margin-right: 6px;
    }
  }
  #navdiv {
    //float: right;
    height: $Tbar-height;
    div {
      opacity: 0.7;
      position: relative;
      border-bottom: solid 3px transparent;
      line-height: calc(#{$Tbar-height} - 1.5px);
      cursor: pointer;
      &.router-link-active {
        opacity: 1;
        border-bottom: solid 3px rgb(255, 187, 0);
        color: rgb(255, 187, 0);
      }
      &:hover { opacity: 1; }
      img {
        height: 1.5rem;
        transform: translateY(2px);
      }
      span {
        font-size: 1rem;
        transform: translateY(2px);
      }
    }
  }
  &.phone {
    padding: 0;
    #navdiv {
      div {
        margin-left: 0.95rem !important;
      }
      img {
        height: 1.2rem;
      }
      span {
        font-size: 0.85rem !important;
      }
    }
  }
}
</style>
